<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <template v-if="is_category">
        <v-flex xs12>
          <v-toolbar color="#eee" class="elevation-0 secondary--text">
            <v-toolbar-title>Categorias</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn
                icon
                color="secondary"
                slot="activator"
                @click="is_category = false"
              >
                <v-icon>local_gas_station</v-icon>
              </v-btn>
              <span>
                Exibir Combustíveis
              </span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn icon color="info" slot="activator" @click="dialogAdicionarCategoria = true">
                <v-icon>add</v-icon>
              </v-btn>
              <span>Adicionar Nova Categoria</span>
            </v-tooltip>
            <v-dialog
              v-model="dialogAdicionarCategoria"
              v-if="dialogAdicionarCategoria"
              :fullscreen="$vuetify.breakpoint.xs"
              width="500"
            >
              <adicionar-categoria
                v-on:fechar="
                  dialogAdicionarCategoria = false,
                  categoriaSelecionada = undefined
                "
                v-on:info="showInfo"
                v-on:error="showError"
                @carregar="pegarCategorias"
                :categoria="categoriaSelecionada"
                persistent
              ></adicionar-categoria>
            </v-dialog>
          </v-toolbar>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headersCategoria"
            :items="categorias"
            :loading="loading"
            hide-actions
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-avatar v-if="props.item.icone && props.item.icone !== ''">
                  <v-icon :color="props.item.cor">{{props.item.icone}}</v-icon>
                </v-avatar>
              </td>
              <td class="text-xs-left">{{ props.item.nome }}</td>
              <td class="text-xs-left">{{ props.item.referencia }}</td>
              <td class="text-xs-right">
                <v-btn
                  icon
                  flat
                  color="info"
                  @click="
                    categoriaSelecionada = props.item,
                    dialogAdicionarCategoria = true
                  "
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn flat icon color="red" @click="deletar(props.item.id)">
                  <v-icon>close</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </template>
      <template v-else>
        <v-flex xs12>
          <v-toolbar color="#eee" class="elevation-0 secondary--text">
            <v-toolbar-title>Combustíveis</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn icon color="secondary" slot="activator" @click="is_category = true">
                <v-icon>category</v-icon>
              </v-btn>
              <span>
                Exibir Categorias
              </span>
            </v-tooltip>
            <v-dialog
              v-model="dialogAdicionarCombustivel"
              lazy
              :fullscreen="$vuetify.breakpoint.xs"
              width="500"
            >
              <v-btn icon color="info" slot="activator">
                <v-icon>add</v-icon>
              </v-btn>
              <adicionar-combustivel
                v-on:fechar="dialogAdicionarCombustivel = false"
                v-on:info="showInfo"
                v-on:error="showError"
              ></adicionar-combustivel>
            </v-dialog>
          </v-toolbar>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headersCombustiveis"
            :items="combustiveis"
            :loading="loading"
            hide-actions
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-avatar v-if="props.item.icone && props.item.icone !== ''">
                  <svg-filler
                    :path="require(`@/assets/combs/${props.item.icone}.svg`)"
                    width="50px"
                    height="50px"
                    :fill="props.item.color"
                  />
                </v-avatar>
              </td>
              <td class="text-xs-left">{{ props.item.nome }}</td>
              <td class="text-xs-left">{{ props.item.ref }}</td>
              <td class="text-xs-right">
                <v-btn icon flat color="info" @click="editarCombustivel(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn flat icon color="red" @click="apagarCombustivel(props.item)">
                  <v-icon>close</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </template>
    </v-layout>
    <v-dialog
      v-model="dialogEditarCombustivel"
      lazy
      :fullscreen="$vuetify.breakpoint.xs"
      width="500"
    >
      <editar-combustivel
        v-on:fechar="dialogEditarCombustivel = false"
        v-on:info="showInfo"
        v-on:error="showError"
        v-on:complete="success"
      ></editar-combustivel>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import AdicionarCombustivel from '@/components/cadastros/CadCombustivel'
import AdicionarCategoria from '@/components/cadastros/CadCategoria'
import EditarCombustivel from '@/components/dialogs/DialogEditarCombustivel'
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: {
      EditarCombustivel,
      AdicionarCombustivel,
      SmartLockMessage,
      AdicionarCategoria
    },
  data () {
    return {
      is_category: true,
      dialogAdicionarCombustivel: false,
      dialogAdicionarCategoria: false,
      pagination: {},
      dialogEditarCombustivel: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      categorias: [],
      categoriaSelecionada: undefined,
      headersCombustiveis: [
        { text: '',
          align: 'left',
          sortable: false,
          value: 'icone'
        },
        { text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        { text: 'Referência',
          align: 'left',
          sortable: false,
          value: 'ref'
        },
        {
          value: 'acao',
          sortable: false,
          align: 'right'
        }
      ],
      headersCategoria: [
        { text: '',
          align: 'left',
          sortable: false,
          value: 'icone'
        },
        { text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        { text: 'Referência',
          align: 'left',
          sortable: false,
          value: 'referencia'
        },
        {
          value: 'acao',
          sortable: false,
          align: 'right'
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    totalItems () {
      return this.$store.getters.totalItemsCombustiveis
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    smartLock () {
      return this.$store.getters.smartLock
    }
  },
  watch: {
    pagination: {
      handler () {
        this.$store.dispatch('carregarCombustiveis', this.pagination)
      },
      deep: true
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        if (this.is_category) this.pegarCategorias()
        else this.$store.dispatch('carregarCombustiveis', this.pagination)
      }
    },
    is_category (val) {
      if (val) this.pegarCategorias()
      else this.$store.dispatch('carregarCombustiveis', this.pagination)
    }
  },
  mounted () {
    if (this.headers) {
      if (this.is_category) this.pegarCategorias()
      else this.$store.dispatch('carregarCombustiveis', this.pagination)
    }
  },
  methods: {
    success (message) {
      this.$store.dispatch('carregarCombustiveis', this.pagination)
      this.dialogEditarCombustivel = false
      this.dialog = false
      this.showInfo(message)
    },
    editarCombustivel (combustivel) {
      this.$store.dispatch('selectCombustivel', combustivel)
      this.dialogEditarCombustivel = true
    },
    fecharDialogCombustivel () {
      this.dialog = false
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    apagarCombustivel (combustivel) {
      this.$store.dispatch('removeCombustivel', combustivel).then(() => {
        this.$store.dispatch('carregarCombustiveis', this.pagination)
        this.showInfo('Combustível removido com sucesso')
      }).catch(() => {
        this.showError('Não foi possível remover o combustível')
      })
    },
    pegarCategorias () {
      this.$store.dispatch('categorias', {
        method: 'GET'
      }).then(json => {
        this.categorias = json
      })
    },
    deletar (id) {
      this.$store.dispatch('categorias', {
        method: 'DELETE',
        id: id
      }).then(() => {
        this.pegarCategorias()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>
